import { render, staticRenderFns } from "./DestinationWhatsHappeningItem.vue?vue&type=template&id=6594ab65&"
import script from "./DestinationWhatsHappeningItem.vue?vue&type=script&lang=js&"
export * from "./DestinationWhatsHappeningItem.vue?vue&type=script&lang=js&"
import style0 from "./DestinationWhatsHappeningItem.vue?vue&type=style&index=0&id=6594ab65&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports